import Vue from 'vue'
import '@/components/vant/main.js'

// 引入自定义组件
import Header from '@/components/Header.vue'
import AlertModal from '@/components/AlertModal.vue'

Vue.component('v-header', Header)
Vue.component('alert-modal', AlertModal)
